import { render, staticRenderFns } from "./TplMsg.vue?vue&type=template&id=1ac0d065&scoped=true&"
import script from "./TplMsg.vue?vue&type=script&lang=js&"
export * from "./TplMsg.vue?vue&type=script&lang=js&"
import style0 from "./TplMsg.vue?vue&type=style&index=0&id=1ac0d065&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0d065",
  null
  
)

export default component.exports